import { render, staticRenderFns } from "./copyright.vue?vue&type=template&id=437ff906&scoped=true&"
import script from "./copyright.vue?vue&type=script&lang=ts&"
export * from "./copyright.vue?vue&type=script&lang=ts&"
import style0 from "./copyright.vue?vue&type=style&index=0&id=437ff906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437ff906",
  null
  
)

export default component.exports